import { envDef, firebaseConfig } from 'src/environments/env.default';

export const environment = {
    ...envDef,
    prefix: 'valida-arquivo',
    version: '1.0.2',
    urlAPI: 'https://arquivo.qa.api.gestor.ladder.dev.br',
    urlBase: 'qa.valida.arquivo.app',
    CrossDomainStorageOrigin: 'https://arquivo.qa.api.gestor.ladder.dev.br',
    firebase: firebaseConfig
};
